<app-card
  #cardComponent
  [title]="'PEOPLE_FORM.FORM.ADDRESSES.SUBTITLE' | translate"
  [index]="index()"
  (deleteCard)="remove.emit()"
  [totalItems]="totalItems()"
>
  <app-address-form [control]="control()" />
</app-card>
